import Tabs, { TabItem } from "../../components/tabs";
import useQueryParams from "../../hooks/useQueryParams";
import useScreenName from "../../hooks/useScreenName";
import LoanListContainer from "./loanListContainer";
import { EnterpriseLoanPageSearchQuery, TabIndex } from "./types";

const tabItems: TabItem<TabIndex>[] = [
  {
    label: "Overdraft Facility",
    value: "COMMERCIAL_OD",
  },
  {
    label: "Working Capital Term Loan",
    value: "WORKING_CAPITAL_TERM_LOAN",
  },
];

const DEFAULT_SEARCH_QUERY_STATE: EnterpriseLoanPageSearchQuery = {
  tab: "COMMERCIAL_OD",
  status: [],
  pageNo: 1,
  numberOfEntitiesPerPage: 10,
};

export default function EnterpriseLoans() {
  useScreenName("Enterprise Loans");
  const [{ tab, numberOfEntitiesPerPage, pageNo, status }, setSearchQuery] =
    useQueryParams<EnterpriseLoanPageSearchQuery>(DEFAULT_SEARCH_QUERY_STATE);

  return (
    <>
      <div className="dashboard-container p-3">
        <Tabs
          items={tabItems}
          value={tab}
          onChange={(val) =>
            setSearchQuery({ ...DEFAULT_SEARCH_QUERY_STATE, tab: val })
          }
        />
      </div>

      <LoanListContainer
        tab={tab}
        queryState={{ pageNo, status, numberOfEntitiesPerPage, tab }}
        onPageChange={(pageNo) =>
          setSearchQuery((prevState) => ({
            ...prevState,
            pageNo,
          }))
        }
        onPerPageCountChange={(countPerPage) =>
          setSearchQuery((prevState) => ({
            ...prevState,
            numberOfEntitiesPerPage: countPerPage,
            pageNo: 1,
          }))
        }
      />
    </>
  );
}
